import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const StoreInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  border-top: 1px solid ${themeGet('colors.white-pale')};
  border-right: 1px solid ${themeGet('colors.white-pale')};
  padding: 0;
  background: transparent;
  cursor: pointer;

  ${({ active }) =>
    active &&
    css`
      outline-color: ${themeGet('colors.phoenix-red')};
      box-shadow: inset 0 0 0 2px ${themeGet('colors.phoenix-red')};
      background: ${themeGet('colors.grey')};
    `}

  &:last-child {
    border-bottom: 1px solid ${themeGet('colors.white-pale')};
  }

  &.view-desktop {
    display: block;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      display: none;
    }
  }

  &.view-mobile {
    display: none;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      display: block;
    }
  }
`;

export const StoreInfoButton = styled.button`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  height: 100%;
  background: transparent;
  padding: 1rem 1rem 1rem 2rem;
  border: none;
  cursor: pointer;

  @media (max-width: ${themeGet('breakpoints.md')}) {
    display: none;
  }
`;

export const StoreInfoWrapper = styled.div`
  display: none;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  height: 100%;
  background: transparent;
  padding: 1rem 1rem 1rem 2rem;

  @media (max-width: ${themeGet('breakpoints.md')}) {
    display: flex;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  img {
    max-height: 1rem;
    max-width: 7rem;
    width: 100%;
  }
`;

export const Logo = styled.div`
  padding: 0.2rem;
  width: 100%;
  max-width: 90px;
`;

export const StoreDistance = styled.div`
  color: ${themeGet('colors.body-copy')};
  font-weight: ${themeGet('fontWeights.medium')};
  justify-self: flex-end;
`;

export const StoreName = styled.div`
  padding-top: 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;

  p {
    text-align: left;
    font-size: 1rem;
    line-height: 1.5;
    margin-bottom: 0;
  }
`;

export const StoreAddress = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  text-align: left;
  font-size: 0.875rem;
  color: ${themeGet('colors.body-copy')};
  line-height: 1.5;
  margin-bottom: 0;
`;

export const CtaContainer = styled.div`
  margin-top: 1rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  &:first-of-type {
    margin-top: 0;
  }

  button {
    font-size: 0.875rem;
    padding: 0.438rem 1.25rem;
    min-height: auto;
    margin: 0;

    &.active {
      pointer-events: none;
      opacity: 0.35;
    }
  }

  a {
    font-size: 0.875rem;
    margin: 0;
    transition: color 150ms ease-out;
    text-align: left;

    @media (max-width: ${themeGet('breakpoints.sm')}) {
      text-align: left;
    }

    > svg {
      display: none;
    }

    &.address {
      width: 220px;
      padding-right: 30px;

      &:hover {
        .directions-icon {
          opacity: 0.7;
          transition: opacity 150ms ease-out;
        }
      }
    }

    .directions-icon {
      justify-self: flex-end;
      width: 2rem;
      height: 2rem;
      position: absolute;
      top: 10px;
      right: -5px;
      opacity: 1;
      transition: opacity 150ms ease-out;
    }
  }
`;

export const Drawer = styled.div`
  display: ${({ open }) => (open ? 'block' : 'none')};
  width: 100%;
  text-align: left;
  margin: 2rem auto 0;
`;

export const StoreNumber = styled.a`
  color: inherit;
  text-decoration: none;
  color: ${themeGet('colors.body-copy')};
  font-size: 0.875rem;
`;

export const StoreHours = styled.div`
  margin-bottom: 1rem;

  ${({ phoneNumber }) =>
    !phoneNumber &&
    css`
      margin-bottom: 0;
    `}

  p {
    font-size: 0.875rem;
    line-height: 1.4;
    margin: 0;
  }
`;
